import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { CandidateEmployerListService } from 'src/app/shared/services/candidate-employer-list.service';
import { AuthService } from 'src/app/store/auth/auth.service';

@Component({
  selector: 'app-assigned-candidate-detail',
  templateUrl: './assigned-candidate-detail.component.html',
  styleUrl: './assigned-candidate-detail.component.scss'
})
export class AssignedCandidateDetailComponent {
  candidateId: any;
  candidateInfo: any = {};
  loginUserData: any = {};
  userO = this.authService.userO;
  private userSub: Subscription;

  constructor(
      private readonly activeRoute: ActivatedRoute,
      private readonly candidateListService: CandidateEmployerListService,
      private readonly authService: AuthService
  ) {}

  ngOnInit() {
    this.userSub = this.userO.subscribe((data) => {
      if (!data) return;
      if (data?.isData === true) {
          this.loginUserData = data?.body;
      }
  });
      this.candidateId = this.activeRoute.snapshot.paramMap.get("id");
      this.getSpecificCandidateDetails()
  }

  getSpecificCandidateDetails() {
      this.candidateListService
          .getSpecificCandidateByIdForEmployer(this.candidateId , this.loginUserData?.email)
          .subscribe((res: any) => {
            this.candidateInfo = res?.body
          });
  }


  ngOnDestroy() {
    this.userSub.unsubscribe();
}
}
